import Loading from 'components/loading/Loading'
import { useSelector } from 'react-redux'
import NoneAnchor from 'components/NoneAnchor'
import WalletSpend from 'features/dashboard/info/WalletSpend'

const TotalContentMatchingInfo = () => {
  const { isLoading } = useSelector(state => state.dashboard.info)
  return isLoading ? (
    <div style={{ height: 368 }}>
      <Loading />
    </div>
  ) : (
    <>
      <strong className="screen_out">정보보기 탭</strong>
      <ul className="tab_g6">
        <li>
          <NoneAnchor className="link_tab fw_bold">비용 정보</NoneAnchor>
        </li>
      </ul>
      <WalletSpend />
    </>
  )
}

export default TotalContentMatchingInfo
